import { gsap } from "gsap";
    
import { Draggable } from "gsap/Draggable";
import { Observer } from "gsap/Observer";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import { TextPlugin } from "gsap/TextPlugin";

gsap.registerPlugin(Draggable,Observer,ScrollTrigger,ScrollToPlugin,TextPlugin);

import Swup from 'swup';
const swup = new Swup({
  containers: ['#swup'],
});

import "./modules/oxg.js"
import "./modules/submenu-toggle.js"
import {oxgFnByName} from './modules/fn-by-name.js'
import {for_each_in} from "./modules/arrays.js"
import {map} from "./modules/arrays.js" 
import {filter} from "./modules/arrays.js"
import "./modules/intersection-observer.js"
import "./modules/show-more-less.js"

const $ = jQuery;

/* ------------------------------------------------------------------------------------------------------------------
--------------------------------------------------------------------- DOM Loaded
------------------------------------------------------------------------------------------------------------------ */

/* ANCHOR ---- Set True and Virtual Viewport CSS Vars ------- */

function doSetViewportCSSVars() {
  let wpAdminBarHeight = 0;
  const wpAdminBar = document.getElementById('wpadminbar');

  if (wpAdminBar) {
    wpAdminBarHeight = wpAdminBar.offsetHeight;
  }
  const viewPortHeight = window.visualViewport ? window.visualViewport.height - wpAdminBarHeight : window.innerHeight - wpAdminBarHeight;
  document.documentElement.style.setProperty('--vh', `${viewPortHeight * 0.01}px`);
  document.documentElement.style.setProperty('--realTop', `${wpAdminBarHeight}px`);
}

function doSetHeaderClass() {
  const header = document.getElementById('oxg-header');
  if(!header) return;
  if (document.body.classList.contains('is-scrolled') && document.body.getAttribute('data-scroll') > 1000) {
    header.classList.add('is-off');
  } else {
    header.classList.remove('is-off');
  }
}

const setHeaderClass = ()=> { doSetHeaderClass() }
const setViewportCSSVars = ()=> { doSetViewportCSSVars() }

/* ANCHOR ---- Resize & Orientation Change -------------------------- */

window.addEventListener('resize', ()=> {
  setViewportCSSVars()
});

window.addEventListener('scroll', ()=> {
  setHeaderClass();
});

window.addEventListener('orientationchange', ()=> {
  setViewportCSSVars()
});

/* ANCHOR ---- DOM Loaded -------------------------- */

document.addEventListener('DOMContentLoaded', () => {

  console.log(performance.now() + ': DOM Content loaded')
  const mainJsEvent = new Event('mainJsLoaded');
  document.dispatchEvent(mainJsEvent);
  setHeaderClass();
  setViewportCSSVars();

  /* ------------------------------------------------------------------------------------------------------------------
  --------------------------------------------------------------------- Window Loaded
  ------------------------------------------------------------------------------------------------------------------ */

  /* ANCHOR ---- Window Loaded -------------------------- */

  window.onload = function() {
      console.log(performance.now() + ': window loaded')

      //log all global variables and functions to the console
      /* for (var b in window) {
          if (window.hasOwnProperty(b)) console.log(b)
      }*/
  }

});

swup.hooks.replace('animation:out:await', async () => {
  await gsap.fromTo('#oxg-main', { opacity: 1 }, { opacity: 0, y: 30, duration: 0.25 });
});

swup.hooks.replace('animation:in:await', async () => {
  await gsap.fromTo('#oxg-main', { opacity: 0, y: 30 }, { opacity: 1, y: 0, duration: 0.25 });
});

